/**
 * Enum representing the different lifecycle states of a message stream.
 */
export enum StreamLifecycleState {
	SEND_CONTEXT_READY = 'send-context-ready',
	COMPLETED = 'completed',
	ERRORED = 'errored',
	ABORTED = 'aborted',
}
